import {memo, useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeCheckboxField from '@s-ui/react-molecule-checkbox-field'
import IconUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import IconChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'

export const USER_CONSENTS = {
  FINANCIAL_SERVICES: 'financial_services',
  WHATSAPP_COMMUNICATIONS_C2B: 'whatsapp_communications_C2B',
  PORTAL_ANNOUNCEMENTS: 'portal_announcements',
  EXTERNAL_SERVICES_OFFERS: 'external_services_offers',
  SEGMENTED_ADS: 'segmented_ads'
}

// eslint-disable-next-line react/prop-types
const Label = ({id}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {
    USER_CONSENTS: {
      FINANCIAL_SERVICES: financialServicesConsentKey,
      WHATSAPP_COMMUNICATIONS_C2B: whatsappConsentKey,
      PORTAL_ANNOUNCEMENTS: portalAnnouncementsConsentKey,
      EXTERNAL_SERVICES_OFFERS: externalServicesOffersConsentKey,
      SEGMENTED_ADS: segmentedAdsConsentKey
    }
  } = config.get('user')

  const LABELS_MAP = {
    [financialServicesConsentKey]: 'USER_PROFILE.CONSENTS.FINANCIAL_SERVICES_LABEL',
    [whatsappConsentKey]: 'USER_PROFILE.CONSENTS.WHATSAPP_LABEL',
    [portalAnnouncementsConsentKey]: 'USER_PROFILE.CONSENTS.PORTAL_ANNOUNCEMENTS_LABEL',
    [externalServicesOffersConsentKey]: 'USER_PROFILE.CONSENTS.EXTERNAL_SERVICES_OFFERS_LABEL',
    [segmentedAdsConsentKey]: 'USER_PROFILE.CONSENTS.SEGMENTED_ADS_LABEL'
  }

  const DESCRIPTIONS_MAP = {
    [financialServicesConsentKey]: 'USER_PROFILE.CONSENTS.FINANCIAL_SERVICES_DESCRIPTION',
    [whatsappConsentKey]: 'USER_PROFILE.CONSENTS.WHATSAPP_DESCRIPTION',
    [portalAnnouncementsConsentKey]: 'USER_PROFILE.CONSENTS.PORTAL_ANNOUNCEMENTS_DESCRIPTION',
    [externalServicesOffersConsentKey]: 'USER_PROFILE.CONSENTS.EXTERNAL_SERVICES_OFFERS_DESCRIPTION',
    [segmentedAdsConsentKey]: 'USER_PROFILE.CONSENTS.SEGMENTED_ADS_DESCRIPTION'
  }

  return (
    <div>
      <div className="mt-FormConsent-title">{i18n.t(LABELS_MAP[id])}</div>
      <p className="mt-FormConsent-description">{i18n.t(DESCRIPTIONS_MAP[id])}</p>
    </div>
  )
}

const MemoizedLabel = memo(Label)

const FormConsent = ({id, consentsStatus, onError, onSuccess, moreInfoUrl = ''}) => {
  const {domain, i18n} = useContext(Context)

  const initialCheckedStatus = consentsStatus?.consents?.find(consent => consent.key === id)?.status
  const [isChecked, setIsChecked] = useState(initialCheckedStatus)

  const handleOnChange = async (ev, {checked}) => {
    consentsStatus.setConsentStatus({
      key: id,
      status: checked
    })
    setIsChecked(checked)

    const [getUpdateConsentsError] = await domain.get('update_consents_user_use_case').execute(consentsStatus)

    if (getUpdateConsentsError) {
      const resetValue = !checked
      setIsChecked(resetValue)
      consentsStatus.setConsentStatus({
        key: id,
        status: resetValue
      })

      return onError(getUpdateConsentsError)
    }

    return onSuccess()
  }

  return (
    <div className="mt-FormConsent">
      <MoleculeCheckboxField
        checked={isChecked}
        checkedIcon={IconChecked}
        id={id}
        nodeLabel={<MemoizedLabel id={id} />}
        onChange={handleOnChange}
        uncheckedIcon={IconUnchecked}
      />
      {moreInfoUrl && (
        <a className="mt-FormConsent-link" target="_blank" href={moreInfoUrl}>
          {i18n.t('USER_PROFILE.CONSENT_MORE_INFO')}
        </a>
      )}
    </div>
  )
}

FormConsent.displayName = 'FormConsent'
FormConsent.propTypes = {
  consentsStatus: PropTypes.object,
  id: PropTypes.string,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  moreInfoUrl: PropTypes.string
}

export default FormConsent
